export default {
  SET_MENU_ITEMS (state, menu_items) {
    state.menu_items = menu_items
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.menu_items.findIndex((u) => u.id === itemId)
    state.menu_items.splice(roleIndex, 1)
  }
}
